'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _quiverAssets = require('@surfline/quiver-assets');

var _quiverAssets2 = _interopRequireDefault(_quiverAssets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://medium.com/@hotdang_ca/how-i-wrote-a-reactjs-adblock-detection-that-didnt-actually-suck-812be52fb1ef
// http://www.detectadblock.com/
var DetectAdBlock = function (_Component) {
  (0, _inherits3.default)(DetectAdBlock, _Component);

  function DetectAdBlock() {
    (0, _classCallCheck3.default)(this, DetectAdBlock);
    return (0, _possibleConstructorReturn3.default)(this, (DetectAdBlock.__proto__ || (0, _getPrototypeOf2.default)(DetectAdBlock)).apply(this, arguments));
  }

  (0, _createClass3.default)(DetectAdBlock, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var head = document.getElementsByTagName('head')[0];
      var oldScript = document.getElementById('quiver-adblock-detection');
      if (oldScript) head.removeChild(oldScript);
      var script = document.createElement('script');
      script.id = 'quiver-adblock-detection';
      script.type = 'text/javascript';
      script.src = _quiverAssets2.default + '/scripts/ads.js';
      script.onload = function () {
        return _this2.props.setAdBlock(false);
      };
      script.onerror = function () {
        return _this2.props.setAdBlock(true);
      };
      head.appendChild(script);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return DetectAdBlock;
}(_react.Component);

DetectAdBlock.propTypes = {
  setAdBlock: _propTypes2.default.func.isRequired
};
exports.default = DetectAdBlock;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/DetectAdBlock/DetectAdBlock.js
// module id = 570
// module chunks = 11